import { PROCESS_ENDPOINTS, REFERENCE_ENDPOINTS } from "../config/constants";

export const getProcesses = async (token) => {
  try {
    const response = await fetch(PROCESS_ENDPOINTS.GET_PROCESSES, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        JobId: null,
        Activities: null,
      }),
    });

    const result = await response.json();
    if (result.success === 1 && Array.isArray(result.data)) {
      return result.data;
    }
    return [];
  } catch (error) {
    console.error("❌ Error cargando procesos:", error);
    return [];
  }
};


export const saveProcess = async (token, process) => {
  try {
    const response = await fetch(`${PROCESS_ENDPOINTS.CREATE_PROCESS}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(process),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error guardando proceso:", error);
    return { success: 0, message: "Error de conexión con el servidor." };
  }
};

export const getActivitiesByProcess = async (token, processId) => {
  try {
    const response = await fetch(PROCESS_ENDPOINTS.GET_ACTIVITIES_BY_PROCESS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ ProcessId: processId }),
    });

    const result = await response.json();

    return result.success === 1 ? result.data : [];
  } catch (error) {
    console.error("❌ Error obteniendo actividades:", error);
    return [];
  }
};

export const saveActivity = async (token, activity) => {
  try {
    const response = await fetch(REFERENCE_ENDPOINTS.SAVE_ACTIVITY, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(activity),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("❌ Error guardando actividad:", error);
    return { success: 0 };
  }
};



export const getBehaviourTypes = async (token) => {
  try {
    const response = await fetch(REFERENCE_ENDPOINTS.GET_BEHAVIOUR_TYPES, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });

    const result = await response.json();
    return result.success === 1 ? result.data : [];
  } catch (error) {
    console.error("❌ Error obteniendo BehaviourTypes:", error);
    return [];
  }
};
